import { render, staticRenderFns } from "./GiftPopup.vue?vue&type=template&id=fdbf469a&"
import script from "./GiftPopup.vue?vue&type=script&lang=js&"
export * from "./GiftPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports